import { mediaDemo } from '../../../demos/media.js';

export const demo = () => mediaDemo('video');
